import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  Typography,
  List,
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  CircularProgress,
} from '@mui/material';
import placeholderThumb from 'styles/assets/placeholder/placeholderThumbTriibo.png';
import { downloadImage } from 'js/library/services/StorageManager.js';
import { recommendOrgs } from 'js/library/utils/API/recommendOrgs.js';
import { getLastUserInfo } from 'js/library/utils/helpers';

import {
  trackEventMatomoElementId,
  trackEventMatomo,
} from 'js/library/utils/helpers';

const verifyLocalization =
  localStorage.getItem('persist:phoneInput') ? JSON.parse(localStorage.getItem('persist:phoneInput')).cellPhone.substring(
    1,
    4
  ) === ('+57' || '+59') : null;

export const HomeTriibosSuggestion = (reloadOrgs) => {
  const [orgs, setOrgs] = React.useState(false);
  let timeDebounce = null;

  const { t } = useTranslation();

  const userInfo = getLastUserInfo();

  if (!orgs || reloadOrgs.orgs) {
    recommendOrgs(userInfo.uId).then((result) => {
      if (result.success) {
        setOrgs(result.orgs);
      } else {
        setOrgs(null);
      }
    });
  }

  function downloadImageOnLoad(i) {
    if (orgs[i].downloaded === undefined) {
      const img = orgs[i].thumbnail.split('/');
      downloadImage(img[0], img[1])
        .then((downloadedImg) => {
          let array = [...orgs];
          array[i].downloaded = downloadedImg;

          setOrgs(array);
        })
        .catch((error) => {
          return error;
        });
    }
  }

  function scrollMatomo() {
    clearTimeout(timeDebounce);
    timeDebounce = setTimeout(() => {
      trackEventMatomo(
        'SugeridosParaVoce',
        'scroll',
        'lista',
        'sugeridos para você'
      );
    }, 400);
  }

  return (
    <>
      {verifyLocalization ? null : (
        <div className="home-paper-triibos">
          <Typography
            variant="body1"
            className="home-paper-triibos-title"
            style={{ color: '#6e3296', fontWeight: 600 }}
          >
            {t('home.suggestions_to_you')}
          </Typography>

          <div onScroll={() => scrollMatomo()} className="home-paper-list">
            <List>
              {orgs === false || reloadOrgs.orgs ? (
                <div style={{ textAlign: 'center' }}>
                  <CircularProgress color="primary" />
                </div>
              ) : orgs === null || orgs.length === 0 ? (
                <div style={{ padding: '0px 5px' }}>
                  <Typography variant="subtitle2" color="secondary">
                    {t('home.dont_have_any_recommendations')}
                  </Typography>
                </div>
              ) : (
                orgs.map((triibo, i) => {
                  return (
                    <Link
                      key={triibo.orgID}
                      to={{
                        pathname: '/triibos/',
                        search: '?id=' + triibo.orgID,
                        state: triibo,
                      }}
                      style={{ textDecoration: 'none' }}
                      onClick={() => {
                        trackEventMatomoElementId(
                          'SugeridosParaVoce',
                          'tocar',
                          'sugeridos',
                          triibo.orgID
                        );
                      }}
                    >
                      <ListItem>
                        <ListItemAvatar>
                          <Avatar>
                            <img
                              src={
                                triibo.downloaded === undefined
                                  ? placeholderThumb
                                  : triibo.downloaded
                              }
                              width="100%"
                              alt="thumb"
                              onLoad={() => downloadImageOnLoad(i)}
                            />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          style={{ color: 'black' }}
                          primary={triibo.name}
                        />
                      </ListItem>
                    </Link>
                  );
                })
              )}
            </List>
          </div>
        </div>
      )}
    </>
  );
};

export default HomeTriibosSuggestion;
